import {
  Typography,
  Input,
  IconButton,
  Button,
  Select,
  MenuItem,
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import { GeneralHeader, ProfilePicker } from "../common";
import { fetchResetPasswordLink } from "../../service/logic";
import { getOptions } from "../../service/api/option";
import { history } from "../../index";
import { getOne, update } from "../../service/api/common";
import { setAuthToken, showModal } from "../../redux/dispatchers";
import { AuthAPI } from "../../service/api";

const useStyles = makeStyles((theme) => ({
  canvas: {
    width: "100vw",
    height: "100vh",
    backgroundColor: "#E5E5E5",
  },
  container: {
    display: "flex",
    paddingTop: 40,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    paddingBottom: 20,
    // background: "#457B9D",
    backgroundColor: "#E5E5E5",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    background: "#C4C4C4",
    borderRadius: 20,
    padding: 20,
    flexWrap: "wrap",
    width: "90%",
  },
  saveButton: {
    margin: 10,
    backgroundColor: "#31BE00",
    color: "white",
    textTransform: "none",
  },
  resetButton: {
    margin: 10,
    textTransform: "none",
  },
  resetPasswordButton: {
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      backgroundColor: "#7B0000",
    },
    height: 40,
    width: 200,
    background: "#7B0000",
    color: "White",
    textTransform: "none",
  },
  resetPasswordContainer: {
    display: "flex",
    marginTop: 10,
    justifyContent: "flex-end",
  },
  detail: {
    display: "flex",
    margin: 10,
  },
  inputLabelSm: {
    flex: 2,
    display: "flex",
    alignItems: "center",
  },
  inputLabel: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  inputField: {
    flex: 5,
    backgroundColor: "white",
    paddingLeft: 10,
    paddingRight: 10,
  },
}));

const Label = ({ label, value, edit, type, onChange, options, isWidthSm }) => {
  const classes = useStyles();

  const mapStage = () => {
    const strings = value.split("_");

    return strings[strings.length - 1];
  };

  const renderInput = () => {
    if (!edit) {
      return (
        <Typography variant={isWidthSm ? "h5" : "h4"} style={{ flex: 5 }}>
          {options && value ? mapStage(value) : value}
        </Typography>
      );
    }

    if (type === "text") {
      return (
        <Input
          className={classes.inputField}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          value={value}
        />
      );
    } else if (type === "dropdown") {
      return (
        <Select
          className={classes.inputField}
          value={value}
          onChange={(event) => {
            onChange(event.target.value);
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      );
    } else return null;
  };

  return (
    <div className={classes.detail}>
      <Typography
        className={isWidthSm ? classes.inputLabelSm : classes.inputLabel}
        variant={isWidthSm ? "h5" : "h4"}
      >
        {label}:
      </Typography>
      {renderInput()}
    </div>
  );
};

const Profile = () => {
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));
  const classes = useStyles();
  const [user, setUser] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [reload, setReload] = useState(false);
  const [stageOption, setStageOption] = useState([]);
  const { id } = useSelector((state) => state.authDetails);

  const {
    email,
    name,
    matricNumber,
    nickname,
    stage,
    oldMatricNumber,
    cohort,
    profile,
  } = user;

  const updateField = (name, value) => {
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigateBack = () => {
    history.goBack();
  };

  const saveUserProfile = async () => {
    update("users", user)
      .then(() => {
        setEditMode(false);
        showModal(
          "Update Profile",
          "Successfully updated profile.",
          null,
          "Close"
        );
        setReload(!reload);
        // refresh token to update header
        AuthAPI.refresh().then((result) => {
          const { accessToken } = result;
          // replace the access token stored in redux store
          setAuthToken(accessToken);
        });
      })
      .catch((e) => {
        showModal("Update Profile", e, null, "Close");
      });
  };

  const resetPassword = async () => {
    await fetchResetPasswordLink(user.email);
  };

  // on load, load the options and user profile
  useEffect(() => {
    getOptions("stage").then((d) => setStageOption(d));
    getOne("users", id).then(({ data }) => {
      setUser(data);
    });
  }, [id, reload]);

  const onEditClick = () => {
    setEditMode(!editMode);
  };

  return (
    <div className={classes.canvas}>
      <GeneralHeader backArrow mode="User Profile" navigate={navigateBack} />
      <div className={classes.container}>
        <ProfilePicker
          value={profile}
          setValue={(v) => {
            setEditMode(true);
            updateField("profile", v);
          }}
        />
        <div className={classes.content}>
          <div style={{ flex: 1 }}>
            <Label
              isWidthSm={isWidthSm}
              label="Name"
              value={name}
              edit={editMode}
              type="text"
              onChange={(v) => {
                updateField("name", v);
              }}
            />
            <Label
              isWidthSm={isWidthSm}
              label="Nickname"
              value={nickname}
              edit={editMode}
              type="text"
              onChange={(v) => {
                updateField("nickname", v);
              }}
            />
            <Label
              isWidthSm={isWidthSm}
              label="Old Matric Number"
              value={oldMatricNumber}
              edit={editMode}
              type="text"
              onChange={(v) => {
                updateField("oldMatricNumber", v);
              }}
            />
            <Label
              isWidthSm={isWidthSm}
              label="Matric Number"
              value={matricNumber}
              edit={editMode}
              type="text"
              onChange={(v) => {
                updateField("matricNumber", v);
              }}
            />
            <Label
              isWidthSm={isWidthSm}
              label="Cohort"
              value={cohort}
              edit={editMode}
              type="text"
              onChange={(v) => {
                updateField("cohort", v);
              }}
            />
            <Label
              isWidthSm={isWidthSm}
              label="Stage"
              value={stage}
              edit={editMode}
              type="dropdown"
              options={stageOption}
              onChange={(v) => {
                updateField("stage", v);
              }}
            />
            <Label isWidthSm={isWidthSm} label="Email" value={email} />
            {editMode ? (
              <div>
                <Button
                  className={classes.saveButton}
                  variant="contained"
                  onClick={saveUserProfile}
                >
                  Save
                </Button>
                <Button
                  className={classes.resetButton}
                  variant="contained"
                  onClick={() => {
                    getOne("users", id).then(({ data }) => {
                      setUser(data);
                    });
                  }}
                >
                  Reset
                </Button>
              </div>
            ) : null}
          </div>
          <div>
            <IconButton onClick={onEditClick}>
              {editMode ? <CloseIcon /> : <EditOutlinedIcon />}
            </IconButton>
          </div>
        </div>
        <div className={classes.resetPasswordContainer}>
          <Button
            className={classes.resetPasswordButton}
            onClick={resetPassword}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
